export default "__VITE_ASSET__U7U_jlXO__"